import React, { useContext } from "react";
import { T, useTranslateKey } from "../../hooks/useTranslate";

import { useNavigate, useLocation } from "react-router-dom";

import { DateTime } from "luxon";

import { Box, Link } from "@mui/material"
import { OfficeAvatar } from "../../components/OfficeAvatar";

import { LanguageContext } from "../../hooks/LanguageContext";

const MobileLeftCell = ({ params }) => {
  const { currentLanguage, localizeNumber } = useContext(LanguageContext);

  const localizedNumber = localizeNumber(params.count);

  const navigate = useNavigate();
  const location = useLocation();

  const handleArrowClick = () => {
    navigate(`${location.pathname}?drawer=member&id=${params.unicityId}&drawerContent=profile`, { state: { location: location, } });
  }

  const translateDateString = useTranslateKey("date");

  const formatDateTime = () => {
    if (params.lastFeelGreatOrderDate) {
      const formattedDate = DateTime.fromISO(params.lastFeelGreatOrderDate).setLocale(currentLanguage.split("-")[0]).toLocaleString(DateTime.DATE_MED);
      return `${translateDateString}: ${formattedDate} • `
    } return null
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
      <Box>
        <OfficeAvatar firstInitial={formatInitial(params.name)} addBadge={true} badgeOn={params.count !== 0} id="user-avatar" />
      </Box>
      <Box>
        <Link
          onClick={handleArrowClick}
          sx={{
            fontSize: "12px",
            fontWeight: "600",
            opacity: params.count !== 0 ? "" : "70%",
            cursor: "pointer",
            textDecoration: "none"
          }}>{formatName(params.name)}
        </Link>
        <Box sx={{ fontSize: "11px", opacity: ".6" }}>
          {formatDateTime()}<T>count</T>: {localizedNumber}
        </Box>
      </Box>
    </Box>
  )
}

export { MobileLeftCell }

function formatInitial(name) {
  if (name.includes(", ")) {
    return name.split(", ")[1][0]
  } return name[0]
}

function formatName(name) {
  if (name.includes(", ")) {
    const splitName = name.split(", ");
    return `${splitName[1]} ${splitName[0]}`
  } return name
}